<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'stats_user_infos.productivite' | trans" [widget]="widget()" [filter]="true" [editable]="editable()">
    <ng-content/>
    <vl-widget-period-filters class="filter" [(period)]="period" [(timeScale)]="timeScale" [(comparison)]="comparison"/>
    @if (familleElements().length > 2) {
      <vl-chips-toggle [elements]="familleElements()" [(value)]="selectedFamille"/>
    }
  </vl-widget-title>

  @if (stats() === null) {
    <vl-loader-skeleton [count]="3" [height]="40"/>
  } @else if (chartData().labels.length) {
    <div class="chart-area fade-in">
      <canvas #prodChart></canvas>
    </div>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
</div>
